import { useEffect } from "react";
import {
  registerNoAuthComponent,
  unregisterNoAuthComponent,
} from "@utils/stores/authStore.ts";

/**
 * Custom hook for components to easily opt out of auth checks
 *
 * Usage:
 * ```tsx
 * const MyComponent = () => {
 *   useNoAuth("MyComponent"); // This component won't trigger auth checks
 *
 *   return <div>My component content</div>;
 * };
 * ```
 *
 * @param componentId - Unique identifier for the component
 */
export const useNoAuth = (componentId: string) => {
  useEffect(() => {
    registerNoAuthComponent(componentId);

    return () => {
      unregisterNoAuthComponent(componentId);
    };
  }, [componentId]);
};
